// src/app/pipes/slugify.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'slugify' })
export class SlugifyPipe implements PipeTransform {
  transform(value: unknown): string {
    const s =
      typeof value === 'string'
        ? value
        : value === null || value === undefined
          ? ''
          : String(value);

    return s
      .trim() // remove surrounding whitespace
      .toLowerCase() // lowercase
      .normalize('NFD') // decompose accented letters
      .replace(/[\u0300-\u036f]/g, '') // remove diacritics
      .replace(/[^a-z0-9]+/g, '-') // replace non-alphanumerics with dash
      .replace(/^-+|-+$/g, ''); // trim leading/trailing dashes
  }
}
